<template>
  <div :class="$style.container">
    <template v-if="!props.hasPrelimVoted">
      <div :class="[$pgCTStyle.headerContainer, $style.headerContainer]">
        <div :class="$pgCTStyle.title">{{ $t("prelim-vote") }}</div>
      </div>
      <div :class="$pgCTStyle.bodyContainer">
        <div :class="$style.questionContainer">
          <div :class="$style.question">{{ $t("most-probable") }}</div>
          <div :class="$style.options">
            <label
              v-for="option in props.texts"
              :key="option.id"
              :class="[$style.option, primaryChoiceTextId === option.id ? $style.selected : '']"
            >
              <input
                type="radio"
                name="primaryChoice"
                :value="option.id"
                v-model="primaryChoiceTextId"
                :class="$style.hiddenRadio"
              />
              <span :class="$style.radio"></span>
              <span :class="$style.label">{{ $t("text") }} {{ option.label }}</span>
            </label>
          </div>
        </div>
        <div :class="[$style.questionContainer, $style.questionContainerSeparator]">
          <div :class="$style.question">{{ $t("second-probable") }}</div>
          <div :class="$style.options">
            <label
              v-for="option in props.texts"
              :key="option.id"
              :class="[$style.option, secondaryChoiceTextId === option.id ? $style.selected : '']"
            >
              <input
                type="radio"
                name="secondaryChoice"
                :value="option.id"
                v-model="secondaryChoiceTextId"
                :class="$style.hiddenRadio"
              />
              <span :class="$style.radio"></span>
              <span :class="$style.label">{{ $t("text") }} {{ option.label }}</span>
            </label>
          </div>
        </div>
        <div
          v-if="props.enablePreliminaryReason"
          :class="[$style.questionContainer, $style.questionContainerSeparator]"
        >
          <div :class="$style.question">{{ $t("prelim-reason") }}:</div>
          <div :class="$style.textBox">
            <input type="text" :placeholder="$t('type-prelim-reason') + '...'" v-model="prelimVoteReason" />
          </div>
        </div>
        <div :class="$style.ctaContainer">
          <PGComponentActionButton
            :text="$t('submit-vote')"
            :iconLink="voteIcon"
            :clickFunction="handleSubmitPrelimVote"
            backBg="#A14000"
            frontBg="#DB7532"
            textColor="#FFFFFF"
            :rightIcon="true"
            :buttonWidth="isMobile ? '180px' : isTablet ? '220px' : '260px'"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <div :class="$style.voteSubmittedContainer">
        <img :class="$style.successIcon" :src="successIcon" alt="Success" />
        <div :class="$style.successText">{{ $t("prelim-submit") }}</div>
        <div :class="$style.successSubText">{{ $t("prelim-wait") }}</div>
      </div>
    </template>
  </div>
</template>

<script setup>
import styles from "@/css/CastVoteBoxForPlayer.module.css";
import playGameComponentsTemplateStyles from "@/css/PlayGameComponentsTemplate.module.css";
// import globalStyles from "@/css/global.module.css";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import VoteIcon from "@/assets/icons/rubber-stamp.svg";
import SuccessIcon from "@/assets/icons/verified-account.svg";
import { useI18n } from "vue-i18n";

const { t: translate } = useI18n();
import PGComponentActionButton from "../buttons/PGComponentActionButton.vue";
import useDeviceType from "@/utils/useDeviceType";

const device = useDeviceType();

// const width = device.width.value;
// const height = device.height.value;
const isMobile = device.isMobile.value;
const isTablet = device.isTablet.value;
// const isDesktop = device.isDesktop.value;

const $style = styles;
const $pgCTStyle = playGameComponentsTemplateStyles;
// const $globalStyle = globalStyles;
const voteIcon = VoteIcon;
const successIcon = SuccessIcon;

const primaryChoiceTextId = ref(null);
const secondaryChoiceTextId = ref(null);
const prelimVoteReason = ref("");
//const prelimVoteSubmitted = ref(false);

// eslint-disable-next-line
const props = defineProps({
  texts: {
    type: Array,
    required: true,
  },
  enablePreliminaryReason: {
    type: Number,
    required: true,
  },
  submitPrelimVote: {
    type: Function,
    required: true,
  },
  hasPrelimVoted: 
  {
    type: Boolean,
    required: true,
  },
});

async function handleSubmitPrelimVote() {
  // console.log("primaryChoiceTextId: ", primaryChoiceTextId.value);
  // console.log("secondaryChoiceTextId: ", secondaryChoiceTextId.value);
  // console.log("prelimVoteReason: ", prelimVoteReason.value);

  if (!primaryChoiceTextId.value) {
    toast(translate("error-select-primary"), { type: "error" });
    return;
  }

  if (!secondaryChoiceTextId.value) {
    toast(translate("error-select-secondary"), { type: "error" });
    return;
  }

  if (primaryChoiceTextId.value === secondaryChoiceTextId.value) {
    toast(translate("error-select-different"), { type: "error" });
    return;
  }

  if (!prelimVoteReason.value && props.enablePreliminaryReason) {
    toast(translate("error-prelim-reason"), { type: "error" });
    return;
  }

  let prelimVoteObj = {
    votedTextId1: primaryChoiceTextId.value,
    votedTextId2: secondaryChoiceTextId.value,
    voteReason: prelimVoteReason.value,
  };

  // emit a function
  try {
    await props.submitPrelimVote(prelimVoteObj);

    // if (prelimVoteRes) {
    //   // show vote submitted screen
    //   prelimVoteSubmitted.value = true;
    // }
  } catch (error) {
    console.error("Failed to submit prelim vote:", error);
  } finally {
    // do any common loader here
  }
}
</script>

<style scoped></style>
